export default class User {
    constructor(data = {}) {
        this.userId = data.userId || null;
        this.password = data.password || null;
        this.displayName = data.displayName || 'UNKNOWN';
        this.role = data.role || 'guest';
        this.isAdmin = data.isAdmin || false;
        this.sessionId = data.sessionId || null;
        this.sessionName = data.sessionName || null;
    }
}